import { MessagePosition } from '../message/types';

export type NotificationStatus = 'info' | 'success' | 'error' | 'warning';
export const NotificationPosition = MessagePosition;
export type NotificationPositionType = (typeof NotificationPosition)[keyof typeof NotificationPosition];
